<script setup lang="ts">
import { getIconComponent } from './icons/utils';

interface ActionButton {
	index: number|string;
	title: string;
	disabled: boolean;
	hidden: boolean;
	onClick: (index: number|string) => void;
}

const props = defineProps<{
	edit: ActionButton,
	remove: ActionButton,
	icon?: string,
}>();

</script>

<template>
	<span
		:class="[
			'editable-list__text',
			props.icon ? 'editable-list__text--icon': '',
		]"
	>
		<span class="editable-list__icon" aria-hidden="true" v-if="props.icon">
			<component :is="getIconComponent(props.icon)" />
		</span>
		<slot></slot>
	</span>
	<span class="editable-list__actions">
		<button v-if="!props.edit.hidden"
			class="button--list-action"
			type="button"
			v-on:click="props.edit.onClick(props.edit.index)"
			:disabled="props.edit.disabled"
			:aria-label="props.edit.title"
		>
			<span class="icon icon-edit" aria-hidden="true"></span>
		</button>
		<button v-if="!props.remove.hidden"
			class="button--list-action"
			type="button"
			v-on:click="props.remove.onClick(props.remove.index)"
			:disabled="props.remove.disabled"
			:aria-label="props.remove.title"
		>
			<span class="icon icon-delete"></span>
		</button>
	</span>
</template>
